import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPrinter2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconPrinter2"><Path fillRule="evenodd" clipRule="evenodd" d="M15 8C16.1046 8 17 8.89543 17 10V19C17 20.1046 16.1046 21 15 21H9C7.89543 21 7 20.1046 7 19V10C7 8.89543 7.89543 8 9 8H15ZM10 16.5H12.5V15H10V16.5ZM10 12.5H14V11H10V12.5Z" fill="currentColor"/><Path d="M19 3C20.6569 3 22 4.34315 22 6V9C22 10.6569 20.6569 12 19 12H18.5V10C18.5 8.067 16.933 6.5 15 6.5H9C7.067 6.5 5.5 8.067 5.5 10V12H5C3.34315 12 2 10.6569 2 9V6C2 4.34315 3.34315 3 5 3H19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPrinter2;
